import React from "react";
import media from "../../../../media";
import { useDispatch, useSelector } from "react-redux";

const StartPanel = () => {
  const { user } = useSelector((state) => state?.auth || {});
  return (
    <div className="seller_user">
      <div className="card card-custom gutter-b p-5">
        <div className="d-flex">
          <div className="flex-shrink-0 mr-7 mt-lg-0 mt-3">
            <div className="border border-2 border-light-dark h-80px overflow-hidden symbol-circle symbol-success w-80px rounded-circle">
              <img
                src={user?.imageUrl?.url || media.Default}
                alt=""
                className="h-80px w-80px object-fit-contain"
              />
            </div>
          </div>

          <div className="d-flex flex-column mt-3">
            <span className="d-block font-size-h6 font-weight-bold text-dark-75">
              Welcome to Apni Kheti Ecommerce Seller Panel
            </span>
            <span className="font-size-h3 font-weight-bolder text-primary">
              {user?.name?.en} 
              
            </span>
            {/* <span className="font-size-md font-weight-bold text-muted">
                Punjab, Mohali
              </span> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartPanel;
